exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lv1[data-v-254ef88f]{margin-left:5px;font-size:15px}.lv2[data-v-254ef88f]{margin-left:20px;font-size:14px}.lv3[data-v-254ef88f]{margin-left:40px;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-254ef88f","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Index/Course/Catalog.vue
// module id = zEoD
// module chunks = 1